import * as React from "react"

import { LandingPage } from "../components/landing_page/landing_page"

const IndexPage = () => <LandingPage />

export default IndexPage
